var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    cr_form_item_full: _vm.size === '12',
    cr_form_item_half: _vm.size === '6'
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }